export default __webpack_public_path__ + "static/media/whatapp-icon-benefit-table.c89f20b1.svg";